import axios from '@axios'

export default {
  loadTable(queryFilter) {
    let queryUrl = ''
    queryUrl = `?page=${queryFilter.page - 1}&size=${queryFilter.size}&sort=${queryFilter.sort},${queryFilter.order}`
    if (queryFilter.filter) {
      queryUrl = `/pesquisa?${queryFilter.filter}`
    }
    return axios.get(`/atendimento/convenios${queryUrl}`)
  },
  insertNewConvenio(data) {
    return axios.post('/atendimento/convenios', data)
  },
  editConvenio(data) {
    return axios.put(`/atendimento/convenios/${data.id}`, data)
  },
  deleteConvenio(id) {
    return axios.delete(`/atendimento/convenios/${id}`)
  },
}
